import React, { useMemo } from 'react';
import styled from 'styled-components';

const BackDrop = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 100;
`;

const Container = styled.div`
  position: fixed;
  z-index: 101;
  box-shadow: rgba(16, 32, 45, 0.33) 0px 14px 17px 0px;
  border-radius: 7px;
  background-color: #fff;
  & > div {
    font-size: 10px;
    font-style: normal;
    min-height: 25px;
    font-weight: normal;
    line-height: 1.4;
    white-space: normal;
    font-stretch: normal;
    border-bottom: 1px solid rgba(40, 56, 144, 0.1);
    padding: 6px 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

export default function ({ parent, options, position, onClose, ...props }) {
  if (!options?.length || !parent) return null;

  const style = useMemo(() => {
    if (!parent) return {};

    switch (position) {
      case 'bottom':
        return {
          bottom: window.innerHeight - parent.offsetTop + 8,
          right: window.innerWidth - parent.offsetLeft - parent.offsetWidth
        };
      default:
        return {
          top: parent.offsetTop + parent.offsetHeight + 8,
          right: window.innerWidth - parent.offsetLeft - parent.offsetWidth
        };
    }
  }, [parent, position]);

  return (
    <>
      <BackDrop onClick={onClose} />
      <Container style={style}>
        {options.map((option, index) => (
          <div
            key={'context-menu-' + index}
            onClick={() => {
              if (typeof option?.action === 'function') option.action();
            }}
          >
            {option?.name || ''}
          </div>
        ))}
      </Container>
    </>
  );
}
